export default {
      id: "ic_menu-usage",
      viewBox: "0 0 16 14",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#ic_menu",
      toString: function () {
        return this.url;
      }
    }